import {
  sendMailCorrespondence,
  sendEmailCorrespondence,
} from "./correspondences"
import { useMutation } from "@tanstack/react-query"

export const useSendMailCorrespondence = () => {
  return useMutation({
    mutationFn: sendMailCorrespondence,
  })
}

export const useSendEmailCorrespondence = () => {
  return useMutation({
    mutationFn: sendEmailCorrespondence,
  })
}
